import { createContext, useCallback, useContext, useEffect, useState } from "react";

import { get, getToken, post, setToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setTok] = useState(getToken());
  const [ready, setReady] = useState(false);

  // On load, validate any stored token by fetching the current user.
  useEffect(() => {
    let alive = true;
    (async () => {
      if (!getToken()) {
        setReady(true);
        return;
      }
      try {
        const me = await get("/auth/me");
        if (alive) setUser(me);
      } catch {
        setToken(null);
        if (alive) {
          setTok(null);
          setUser(null);
        }
      }
      if (alive) setReady(true);
    })();
    return () => {
      alive = false;
    };
  }, []);

  const requestCode = useCallback(async (email, fullName) => {
    return post("/auth/request-code", { email, full_name: fullName || null });
  }, []);

  const verifyCode = useCallback(async (email, code) => {
    const res = await post("/auth/verify-code", { email, code });
    setToken(res.access_token);
    setTok(res.access_token);
    setUser(res.user);
    return res;
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTok(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, token, ready, isAuthed: !!token && !!user, requestCode, verifyCode, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}
